import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import { useGlobalAlert } from "../Common/Context/GlobalAlertContext";
import StickyPageLayout from "../Layout/PageLayout/StickyPageLayout";
import CategorySubcategoryView from "./CategorySubcategoryView";
import { Formik } from "formik";
import { categoryInitialValues, catgSubValidationSchema } from "./CatgSubValidationSchema";
import { handleAE_categorySubForm, handleGet_categorySubForm } from "./catgSubModel";
 
  
const CatgSubForm = () => {
  const navigate = useNavigate();
  const { showAlert } = useGlobalAlert();
 
  const location = useLocation();
  const [submitLoading, setSubmitLoading] = useState(false);
  const [categoryOptions, setCategoryOptions] = useState([]);
  
  const initialValues = () => {    
    const data = location.state;    

    if (data === null || data === undefined) {
      return { ...categoryInitialValues,          
          };       
    }
   
    return { ...data,};
  };

  const listProps = {
    type: 'button',
    text: 'List',
    onClick: () => {navigate('/admin/catg-sub-list')}, // 👈 important
    style: { backgroundColor: '#333', color: '#fff' }
   };

  const submitProps = {
    type: 'submit',    
    loading:submitLoading,
  };

  // API
  const fetchOptionsList = async (filt) => {
    if (!filt) return;

    try {
      await handleGet_categorySubForm({
        filter: filt,
        showAlert,
        setDataList:setCategoryOptions, // ✅ pass directly 
      });
    } catch (err) {
      console.error("job post fetchList error:", err);
    }
  };

  useEffect(() => {
    fetchOptionsList({page:1,limit:'all'})
  }, [])
  



  const handleSubmit = async(values, { resetForm }) => {
    // alert(JSON.stringify(values))
    const excludeKeys = ["type", "img_path","category"];
    const formData = new FormData();
    // formData.append("cmp", getAuthToken("cmp_id"));
    // formData.append("uid", getAuthToken("adminToken"));
    
    Object.entries(values).forEach(([key, value]) => {
      if (
        !excludeKeys.includes(key) &&
        value !== null &&
        value !== undefined &&
        value !== ""
      ) {
        formData.append(key, values[key]);
      }
    });
    if (values.img_path instanceof File) {
      formData.append("img_path", values.img_path);      
    }else{formData.delete("img_path"); }
    if(values?.type?.value !== "category"){
      // alert(JSON.stringify(values))
      formData.append("category", values?.category?.value);
      formData.append("action", 'subcategory');
    }    
    handleAE_categorySubForm({
      data:formData,
      showAlert,
      navigate,
      resetForm,
      setLoading:setSubmitLoading,
    })
  }

  return (
  <Formik
    enableReinitialize
    initialValues={initialValues()}
    validationSchema={catgSubValidationSchema}
    onSubmit={handleSubmit}
  >
    {({ handleSubmit, ...props }) => (
    <StickyPageLayout
      title="Manage Category"          
      submitProps={{...submitProps,
       onClick:handleSubmit,
      className:'btn-modern btn-blue'}}
      listProps={listProps}
    > 
    <CategorySubcategoryView
      {...props}
      categoryList={categoryOptions}
    />
       
    </StickyPageLayout>
    )}
  </Formik>
  );
};

export default CatgSubForm;